
<script context="module">
    import Layout from '@/Layouts/Main.svelte';
    export const layout = Layout;
</script>

  <script>
  import { inertia } from '@inertiajs/inertia-svelte';
  import ApplyForm from '@/Partials/ApplyForm.svelte';
  import { slugify } from '@/utils';

  export let posting = {};
  export let sourceOptions = [];
  export let languageOptions = [];
  export let sectorOptions = [];

  // export let app_url;

  // Gabi: He agregado esto para tener la url actual y poder enlazar los botones de compartir
  let currentUrl = '';
  if (typeof window !== 'undefined') {
    currentUrl = encodeURIComponent(window.location.href);
  }

  $: slug = posting.title ? slugify(posting.title) : '-';

  </script>

  <div class="py-8 lg:py-16">
    <div class="container xl:max-w-5xl">
      <div class="pb-10">
        <div class="mb-4">
          <h1 class="text-4xl font-semibold">
            {posting.title}
          </h1>
        </div>
        <div class="text-sm">
          {#if posting.location}<span class="rounded-full bg-blue bg-opacity-10 mr-2 py-1 px-4">{posting.location}</span>{/if}
          {#if posting.sector}<span class="rounded-full bg-blue bg-opacity-10 mr-2 py-1 px-4">{posting.sector}</span>{/if}
          {#if posting.area}<span class="rounded-full bg-blue bg-opacity-10 mr-2 py-1 px-4">{posting.area}</span>{/if}
        </div>
        <div class="pt-6">
          <div>
            <p class="pb-3 font-light">Compartir</p>
            <div class="flex">
              <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`} target="_blank" style="color: #0e76a8;">
                <span class="fa-stack flex justify-center items-center">
                  <i class="fa-thin fa-circle fa-stack-2x"></i>
                  <i class="fa-brands fa-linkedin-in"></i>
                </span>
              </a>
              <a href={`https://wa.me/?text=${currentUrl}`} target="_blank" style="color: #25D366;">
                <span class="fa-stack flex justify-center items-center">
                  <i class="fa-thin fa-circle fa-stack-2x"></i>
                  <i class="fa-brands fa-whatsapp"></i>
                </span>
              </a>
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank" style="color: #3b5998;">
                <span class="fa-stack flex justify-center items-center">
                  <i class="fa-thin fa-circle fa-stack-2x"></i>
                  <i class="fa-brands fa-facebook-f"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="posting">

        {@html posting.description}

      </div>

      <div class="py-6">
        <div>
          <p class="pb-3 font-light">Compartir</p>
          <div class="flex">
            <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`} target="_blank" style="color: #0e76a8;">
              <span class="fa-stack flex justify-center items-center">
                <i class="fa-thin fa-circle fa-stack-2x"></i>
                <i class="fa-brands fa-linkedin-in"></i>
              </span>
            </a>
            <a href={`https://wa.me/?text=${currentUrl}`} target="_blank" style="color: #25D366;">
              <span class="fa-stack flex justify-center items-center">
                <i class="fa-thin fa-circle fa-stack-2x"></i>
                <i class="fa-brands fa-whatsapp"></i>
              </span>
            </a>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank" style="color: #3b5998;">
              <span class="fa-stack flex justify-center items-center">
                <i class="fa-thin fa-circle fa-stack-2x"></i>
                <i class="fa-brands fa-facebook-f"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ApplyForm url={`/oferta/${slug}/${posting.id}`}
    {sourceOptions} {languageOptions} {sectorOptions}
  />
